"use client";
import BookCard from "@/components/shared/BookCard";
import Pagination from "@/components/shared/Pagination";
import React, { useState } from "react";
import bookImage from "@/public/images/bookImage.svg";
import instructorImage from "@/public/images/instructorImage.svg";

const index = () => {
  const [page, setpage] = useState(1);
  return (
    <>
      {" "}
      <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 place-content-center place-items-center">
        {/* {Array.from({ length: 12 }).map((_, i) => (
          <BookCard
            key={i}
            image={bookImage}
            year="1"
            teacherName="مستر محمد عبد الجواد"
            teacherImage={instructorImage}
            subject="الكيمياء"
            price="60"
            description1="كتاب الكيمياء الحرارية والكيمياء النووية للصف الاول الثانوي"
            description2="يحتوى على جزئين  الجزء الاول : شرح المحاضرات  الباب الرابع الكيمياء الحرارية يتكون من 4 محاضرات شرح  الباب الخامس الكيمياء النووية يتكون من 4 محاضرات شرح"
            examNumber="+500"
            starNumber="5"
            fileNumber="+150"
          />
        ))} */}
      </div>
      <Pagination page={page} setpage={setpage} numberOfPages={10} />
    </>
  );
};

export default index;
